{
    "404": "Ah non ! Nous avons fouillé la mer et nous ne trouvons pas votre page !",
    "appError": {
        "title": "Quelque chose s'est mal passé",
        "description": "L'application a rencontré un problème inattendu. Veuillez la recharger ou retourner à votre espace de travail. Si le problème persiste, veuillez contacter l'assistance.",
        "home": "Retour à l'espace de travail"
    }
}
